import {
  Component,
  ElementRef,
  AfterViewInit,
  ViewChild,
  HostListener,
  ViewEncapsulation,
  OnDestroy,
  Input,
  inject,
  effect,
  Signal,
} from '@angular/core';
import { ArrowDrawingService } from '../../services/arrow-drawing.service';

@Component({
  selector: 'app-arrow-wrapper',
  imports: [],
  templateUrl: './arrow-wrapper.component.html',
  styleUrl: './arrow-wrapper.component.css',
  encapsulation: ViewEncapsulation.None,
  providers: [ArrowDrawingService],
})
export class ArrowWrapperComponent implements AfterViewInit, OnDestroy {
  private readonly arrowService = inject(ArrowDrawingService);

  @ViewChild('svgContainer', { static: true })
  svgContainer!: ElementRef<SVGElement>;
  @ViewChild('container', { static: true }) container!: ElementRef<Element>;

  @Input() arrowRedrawSignal?: Signal<number>;
  @Input() paddingBottomInRem = 0;
  @Input() looping = false;
  @Input() showLoopArrow = false;

  constructor() {
    // Effect to handle arrow redraw when signal changes
    effect(() => {
      const redrawValue = this.arrowRedrawSignal?.();
      if (redrawValue !== undefined) {
        this.drawArrows();
      }
    });
  }

  ngAfterViewInit() {
    this.arrowService.initialize(
      this.svgContainer,
      this.container.nativeElement,
    );
    this.drawArrows();
  }

  @HostListener('window:resize')
  onResize() {
    this.drawArrows();
  }

  private drawArrows() {
    setTimeout(() => {
      this.arrowService.drawArrows(this.looping, this.showLoopArrow);
    }, 0);
  }

  ngOnDestroy() {
    this.arrowService.cleanup();
  }
}
